import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vector2",
  "use": "icon-vector2-usage",
  "viewBox": "0 0 3 3",
  "content": "<symbol viewBox=\"0 0 3 3\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vector2\">\n<path d=\"M3 1.43868C2.92446 2.3559 2.44967 2.98176 1.51087 2.99255C0.582864 3.00334 0.0109528 2.42064 0.000162056 1.48185C-0.0106287 0.618585 0.518119 0.057465 1.39217 0.0035112C2.34176 -0.0504426 2.84893 0.521468 3 1.43868Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol